import React from 'react';
import styles from './FooterDomain.module.scss';

type FooterDomainProps = {
  children: React.ReactNode | React.ReactNode[];
};

export const FooterDomain = ({ children }: FooterDomainProps) => <div className={styles.root}>{children}</div>;
